import { useQueryClient } from '@tanstack/react-query'

export function useInvalidateCompanyConsentsQuery() {
  const queryClient = useQueryClient()

  return async function () {
    return queryClient.invalidateQueries({ queryKey: ['company-consents'] })
  }
}
